module.exports = __webpack_public_path__ + "static/img/q_number.56435f8b.png";